import { observer } from 'mobx-react-lite';
import React from 'react';
import { WishlistGA4ProductData, addItemToWishlist, removeItemFromWishlist, wishlistState } from './wishlistState';
import './style.scss';
import { promptAuthAndWishlistFromURL } from './wishlistUtils';
import { IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';

let WishlistIconPLP = ({
  source,
  isCustomer,
  productData,
}: {
  source: string;
  isCustomer: boolean;
  productData: WishlistGA4ProductData;
}) => {
  const productId = productData?.id || '';
  const isWishlisted = wishlistState.productIds.includes(Number(productId));

  const toggleItemInWishlist = () => {
    if (isWishlisted) {
      removeItemFromWishlist(productData, {
        isSignedIn: true,
        productId,
        source,
        'Wishlist Items Count': wishlistState.productIds.length - 1,
      });
    } else {
      addItemToWishlist(productData, {
        isSignedIn: true,
        productId,
        source,
        'Wishlist Items Count': wishlistState.productIds.length + 1,
      });
    }
  };

  if (IS_NATIVE_APP_CLIENT) {
    return null; // wishlist click not supported in native app webview
  }

  return (
    <div>
      <div
        className="wishlist-icon-wrapper"
        onClick={async () => {
          if (!wishlistState.error && wishlistState.productIds && isCustomer) {
            toggleItemInWishlist();
          } else if (wishlistState.error === 'unauthorized' || !isCustomer) {
            promptAuthAndWishlistFromURL(source, productData);
          } else
            console.log('Something went wrong with fetching wishlist: ', {
              productIds: wishlistState.productIds,
              error: wishlistState.error,
            });
        }}
      >
        {isWishlisted ? <span className="icon-wishlist-solid"></span> : <span className="icon-wishlist-static"></span>}
      </div>
    </div>
  );
};

WishlistIconPLP = observer(WishlistIconPLP);
export { WishlistIconPLP };
